import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "./../../../assets/images/logo.svg";
import bar from "./../../../assets/images/menu_bar_mb.svg";
import close from "./../../../assets/images/close_menu_mb.svg";
import style from "./../../../assets/styles/_header.module.scss";
import { useLocation } from "react-router-dom";
import LogoInstagram from "./../../../assets/images/footer/insta.png";
import LogoX from "./../../../assets/images/footer/x.png";
import tiktok from "./../../../assets/images/footer/tiktok.png";
import arrowRight from "./../../../assets/images/arrowRight.svg";

const Header = () => {
  const location = useLocation();
  const hairChackPage = ["/hair-check"];

  // UseEffect để cuộn về đầu khi thay đổi route
  useEffect(() => {
    window.scrollTo(0, 0); // Cuộn về đầu trang
    setIsOpenMebuMobile(false);
  }, [location]);
  const [isOpenMebuMobile, setIsOpenMebuMobile] = useState(false);
  const routeMB = [
    {
      name: "TOP",
      path: "/",
    },
    {
      name: "CONCEPT",
      path: "/concept",
    },
    {
      name: "PRODUCT",
      path: "/products",
    },
    {
      name: "SHOP",
      path: "/shop",
      //   size: "small",
    },
    {
      name: "TOPICS",
      path: "/topics",
      //   size: "small",
    },
    {
      name: "FAQ",
      path: "/faq",
      //   size: "small",
    },
  ];
  const socials = [
    {
      name: "Instagram",
      path: "https://www.instagram.com/my_o2_official/",
      icon: LogoInstagram,
    },
    {
      name: "X",
      path: "https://x.com/myO2_official",
      icon: LogoX,
    },
    // {
    //   name: "TikTok",
    //   path: "https://www.tiktok.com/",
    //   icon: tiktok,
    // },
  ];

  const relationships = [
    {
      id: 1,
      name: "公式ストアで購入する",
      link: "https://shop.beaute-de-mode.jp/collections/myo2",
    },
    {
      id: 2,
      name: "Amazonで購入する", 
      link: "https://www.amazon.co.jp/stores/page/DB0DCA4F-5097-4F8A-944D-15A46616BFC1",
    },
    {
      id: 3,
      name: "Rakutenで購入する",
      link: "https://item.rakuten.co.jp/joiedebeaute/c/0000000184/?l-id=shoptop_shopmenu_shopcategory_4",
    },
    {
      id: 4,
      name: "Yahoo!で購入する",
      link: "https://store.shopping.yahoo.co.jp/beautedemode/myo2a1caa5.html#sideNaviItems",
    },
    {
      id: 5,
      name: "Qoo10で購入する",
      link: "https://www.qoo10.jp/shop/beaute-de-mode?keyword=%E3%83%9E%E3%82%A4%E3%83%BB%E3%82%AA%E3%83%BC%E3%83%84%E3%83%BC&keyword_hist=&dispType=GALLERY4",
    },
  ];
  return (
    <header>
      <nav className={!hairChackPage.includes(location.pathname) ? "" : style.hairCheckNav}>
        <div className={!hairChackPage.includes(location.pathname) ? style.logo : style.logoHairCheck}>
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
        </div>
        <div className={style.menu}>
          <div className={style.itemMenu}>
            <Link to="/concept">CONCEPT</Link>
          </div>
          <div className={style.itemMenu}>
            <Link to="/products">PRODUCT</Link>
          </div>
          <div className={style.itemMenu}>
            <Link to="/shop">SHOP</Link>
          </div>
          <div className={style.itemMenu}>
            <Link to="/topics">TOPICS</Link>
          </div>
          <div className={style.itemMenu}>
            <Link to="/faq">FAQ</Link>
          </div>
          <div className={style.itemMenu}>
            <Link to="/hair-check" style={{ textDecoration: "none" }}>
              <div className={style.btnColor}>髪質診断</div>
            </Link>
          </div>
        </div>
        <div
          className={style.menu_mobile_icon}
          onClick={() => setIsOpenMebuMobile(true)}
        >
          <img src={bar} alt="bar" />
        </div>
        <div
          className={`${style.menu_mobile_wrap} ${
            isOpenMebuMobile ? style.open : ""
          }`}
        >
          <div className={style.menu_mobile}>
            <div className={style.bg}></div>
            <div className={style.bgColor}></div>
            <div className={style.content}>
              <img
                className={style.closeIcon}
                src={close}
                alt="bar"
                onClick={() => setIsOpenMebuMobile(false)}
              />
              <div className={style.menu_mobile_list}>
                {routeMB.map((item, index) => {
                  return (
                    <Link
                      key={index}
                      to={item.path}
                      className={`${style.menu_mobile_item} ${
                        item.size === "small" ? style.small : ""
                      }`}
                    >
                      {item.name}
                    </Link>
                  );
                })}
              </div>
              <Link to="/hair-check" style={{ textDecoration: "none" }}>
                <div className={style.btnColor}>髪質診断</div>
              </Link>
              <div className={style.socials}>
                {socials.map((item, index) => {
                  return (
                    <a
                      key={index}
                      href={item.path}
                      target="_blank"
                      rel="noreferrer"
                      className={style.social_item}
                    >
                      <img src={item.icon} alt={item.name} />
                      {/* <span>{item.name}</span> */}
                    </a>
                  );
                })}
              </div>
              <div className={style.relationshipList}>
                {/* <div className={style.maskComingSoon}>Coming soon…</div> */}

                {relationships.map((item, index) => {
                  return (
                    <a href={item.link} target="_blank" rel="noreferrer">
                      <div className={`${style.relationshipItem}`} key={index}>
                        <div className={style.relationshipName}>{item.name}</div>
                        <img
                          src={arrowRight}
                          className={style.arrowRight}
                          alt="arrowRight"
                        />
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
